/**
 * @generated SignedSource<<87f9f4deca3532d25bcf88ca5c7b1a8c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type sectionStyleSpotlightQuery$data = {
  readonly spotlight: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
          readonly " $fragmentSpreads": FragmentRefs<"contentItemRenderContent">;
        };
      }>;
    } | null;
  } | null;
  readonly " $fragmentType": "sectionStyleSpotlightQuery";
};
export type sectionStyleSpotlightQuery$key = {
  readonly " $data"?: sectionStyleSpotlightQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"sectionStyleSpotlightQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "sectionStyleSpotlightQuery",
  "selections": [
    {
      "alias": "spotlight",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "entityId": "4335"
          }
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "QueueItemConnection",
          "kind": "LinkedField",
          "name": "items",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "QueueItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "entityId",
                          "storageKey": null
                        }
                      ],
                      "type": "Base",
                      "abstractKey": "__isBase"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "contentItemRenderContent"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "queue(filter:{\"entityId\":\"4335\"})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "7f9af60922f61ceb40d07654abd3a15b";

export default node;
